import i18n from '../i18n';

const features = {
  concierge: i18n.t('constants.features.concierge'),
  elevator: i18n.t('constants.features.elevator'),
  children_area: i18n.t('constants.features.children_area'),
  landscape_decore: i18n.t('constants.features.landscape_decore'),
  sport_area: i18n.t('constants.features.sport_area'),

  is_children_room: i18n.t('constants.features.is_children_room'),
  is_conference_hall: i18n.t('constants.features.is_conference_hall'),
  is_wellness_building: i18n.t('constants.features.is_wellness_building'),
  is_panoramic_glazing: i18n.t('constants.features.is_panoramic_glazing'),
  is_beach: i18n.t('constants.features.is_beach'),
  is_walking_area: i18n.t('constants.features.is_walking_area'),
  is_operated_roof: i18n.t('constants.features.is_operated_roof'),

  spa: i18n.t('constants.features.spa'),
  fitness: i18n.t('constants.features.fitness'),
  pool: i18n.t('constants.features.pool'),
  kindergarten: i18n.t('constants.features.kindergarten'),
  tennis_court: i18n.t('constants.features.tennis_court'),
  recreation_zone: i18n.t('constants.features.recreation_zone'),
  fountain: i18n.t('constants.features.fountain'),
  garden: i18n.t('constants.features.garden'),
  helicopter_landing_area: i18n.t('constants.features.helicopter_landing_area'),
  commercial_property: i18n.t('constants.features.commercial_property'),
  cctv_surveillance: i18n.t('constants.features.cctv_surveillance'),
  kpp: i18n.t('constants.features.kpp'),
  restaurant: i18n.t('constants.features.restaurant'),
  billiards: i18n.t('constants.features.billiards'),
  sauna: i18n.t('constants.features.sauna')
};

export default features;



// WEBPACK FOOTER //
// ./src/constants/Features.js